/* eslint-disable arrow-body-style */
// This is only applicable for Employee view of Netchex
import { Box } from '@chakra-ui/react';
import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';

import { isMobileView } from 'constants/isMobileView';
import { NETCHEX_SIDEPANEL_WIDTH } from 'constants/netChexConstants';

import { AccordionNavigation } from './components/netchex/AccordionNavigation';
import { MobileNav } from './components/netchex/MobileNav';

const NetchexPrimaryNav = () => {
  const { l1Module } = useRouteToNavLevels();

  const isMyDataModule = l1Module === 'myData';

  if (!isMyDataModule) return null;

  if (isMobileView()) {
    return <MobileNav />;
  }

  return (
    <Box w={NETCHEX_SIDEPANEL_WIDTH}>
      <AccordionNavigation />
    </Box>
  );
};

export { NetchexPrimaryNav };
